import React from "react";

// Button variants ported from the Quran Fluency admin's structural recipe
// (ADMIN_DESIGN_SYSTEM.md "Button variants"), restyled with this app's own
// hv-* tokens. Source has no destructive/success color in its palette
// equivalent to ours either — [TOKEN: destructive-surface] mapped to an
// OUTLINE coral (not filled) so it stays visually distinct from the filled
// coral primary button, using only tokens design_guidelines.json defines.
const VARIANTS = {
  primary: "bg-hv-coral text-white hover:opacity-90",
  secondary: "bg-white border border-[#E5DFC8] text-hv-navy hover:bg-hv-cream",
  destructive: "bg-white border border-hv-coral text-hv-coral hover:bg-hv-coralTint",
  destructiveFilled: "bg-hv-coral text-white hover:opacity-90",
};

const SIZES = {
  sm: "px-2.5 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-2.5 text-sm",
};

export default function AdminButton({
  variant = "secondary", size = "md", icon: Icon, iconOnly, className = "", children, ...props
}) {
  if (iconOnly) {
    return (
      <button
        {...props}
        className={`w-8 h-8 rounded-full grid place-items-center border border-[#E5DFC8] hover:border-hv-teal text-hv-navy disabled:opacity-50 disabled:cursor-not-allowed transition ${className}`}
      >
        {Icon && <Icon className="w-4 h-4" strokeWidth={2.5} />}
      </button>
    );
  }
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center gap-2 shrink-0 whitespace-nowrap rounded-full hv-heading font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      {Icon && <Icon className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} strokeWidth={2.5} />}
      {children}
    </button>
  );
}
